const Backbone = require('backbone');
const Categorias = require('../../collections/categorias-cardapio');
const ViewCategoria = require('./categoria');

const View = Backbone.View.extend({
	initialize: function() {
		var that = this;
		that.listenTo(Categorias, 'add', that.addCategoria);

		that.render();
	},
	addCategoria: function(model) {
		var that = this;		
		var view = new ViewCategoria({
			model: model
		});
		that.$el.append(view.$el);
	},
	render: function() {
		var that = this;
		that.$el.find('li:not(:first)').remove();
		Categorias.each(function(model) {
			that.addCategoria(model);
		});
	}
});

module.exports = View;


//////////////////
// WEBPACK FOOTER
// ./views/cardapio/categorias.js
// module id = 15
// module chunks = 0